import { BellaTranslator } from '../../../../client/hooks/useTranslator';
import { Config } from '../../../../common/types/config';
import {
    MenuItemType,
    MenuItemInterface,
    MenuSectionInterface,
} from '../../../../client/components/Overlays/Menu/types';
import { getNewProductsUrl } from '../../../../client/urlService';
import { MagalogState } from '../../../../common/types/remoteConfig';
import { phoneNumberToLink } from '../../../../common/helpers/phoneNumber';
import { VictorQaClasses } from '../../../../common/qaIds';
import GaTracking from '../../../../client/ga';

export const ACCOUNT_SECTION_KEY = 'ACCOUNT_SECTION_KEY';

const includeItem = (item: MenuItemInterface, shouldInclude: boolean) => {
    return shouldInclude ? [item] : [];
};

const initialMenuItems: (
    categoryItems: MenuItemInterface[],
    dependencies: {
        t: BellaTranslator;
        ga: GaTracking;
    },
    settings: {
        strict?: boolean;
        search?: boolean;
        isUserLoggedIn: boolean;
        config: Config;
        interiorServiceInNav: boolean;
        magaLogConfig: MagalogState;
    }
) => MenuSectionInterface[] = (categoryItems, { t, ga }, settings) => {
    const { config, interiorServiceInNav, magaLogConfig, isUserLoggedIn, strict, search } = settings;

    const trackClick = (name: string) => {
        if (search) {
            ga.oneHeader.trackSearchClicks(name);
            return;
        }
        ga.oneHeader.trackBurgerItemClick(name);
    };
    if (strict) {
        return [
            {
                key: 'mainMenu',
                items: [
                    ...categoryItems,
                    {
                        title: t('Brands'),
                        url: config.links.brands,
                        itemType: MenuItemType.ExternalLink,
                        trackItemClick: () => trackClick(t('Brands')),
                    },
                    {
                        title: 'Westwing Collection',
                        url: config.links.westwingCollection,
                        itemType: MenuItemType.InternalLink,
                        trackItemClick: () => trackClick('Westwing Collection'),
                    },
                ],
            },
        ];
    }

    const interiorDesignService = {
        title: t('Interior Design Service'),
        url: config.links.interiorService,
        itemType: MenuItemType.ExternalLink,
        highlighted: true,
        trackItemClick: () => trackClick(t('Interior Design Service')),
    };

    const magalog = {
        title: t('Order catalog'),
        url: magaLogConfig.url,
        itemType: MenuItemType.ExternalLink,
        trackItemClick: () => trackClick(t('Order catalog')),
    };

    const referFriend = {
        title: t('Refer_a_friend_menu_item'),
        url: `${config.links.clubBaseUrl}${config.links.clubReferAFriendPath}`,
        itemType: MenuItemType.ExternalLink,
        trackItemClick: () => trackClick(t('Refer_a_friend_menu_item')),
    };

    const inspiration = {
        title: t('Inspiration'),
        url: config.links.olapicUgcGallery,
        itemType: MenuItemType.ExternalLink,
        highlighted: true,
        trackItemClick: () => trackClick(t('Inspiration')),
    };

    const shouldShowInspiration = !!config.links.olapicUgcGallery;

    return [
        {
            key: 'mainMenu',
            items: [
                {
                    title: t('New products'),
                    url: getNewProductsUrl(),
                    itemType: MenuItemType.InternalLink,
                    highlighted: true,
                    trackItemClick: () => trackClick(t('New products')),
                },
                {
                    title: t('Shop the Look'),
                    url: config.links.looks,
                    itemType: MenuItemType.ExternalLink,
                    highlighted: true,
                    trackItemClick: () => trackClick(t('Shop the Look')),
                },
                {
                    title: 'Westwing Collection',
                    url: config.links.westwingCollection,
                    itemType: MenuItemType.InternalLink,
                    highlighted: true,
                    trackItemClick: () => trackClick(t('Westwing Collection')),
                },
                ...includeItem(interiorDesignService, interiorServiceInNav),
                ...includeItem(inspiration, shouldShowInspiration),
                ...categoryItems,
                ...includeItem(referFriend, isUserLoggedIn),
                ...includeItem(magalog, magaLogConfig.toggle),
                {
                    title: t('Brands'),
                    url: config.links.brands,
                    itemType: MenuItemType.ExternalLink,
                    trackItemClick: () => trackClick(t('Brands')),
                },
            ],
        },
        {
            key: 'CustomerService',
            title: t('Customer Service'),
            items: [
                {
                    title: t('Hotline'),
                    url: phoneNumberToLink(config.hotline),
                    itemType: MenuItemType.ExternalLink,
                    className: VictorQaClasses.helpCenterBurgerItem,
                    trackItemClick: () => trackClick(t('Hotline')),
                },
                {
                    title: t('Contact'),
                    url: config.links.respondentContact,
                    itemType: MenuItemType.ExternalLink,
                    trackItemClick: () => trackClick(t('Contact')),
                },
            ],
        },
    ];
};

export default initialMenuItems;
